// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { numberFormatMixins } from '@/app/mixins/modules/number-format-mixins';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

// Service
import StoreCreditService from '@/app/services/main/store-credit/store-credit-service.js';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util';

// Third Party Libraries
import $ from 'jquery';

export default {
	name: 'ModalUpdateStoreCredit',
	props: {
        modalContent: {
            required: true,
            type: Object
        }
    },
	mixins: [
		toastMessageMixins,
		numberFormatMixins
	],
	data() {
		return this.initializeModalData();
	},
	computed: {
		validationRules() {
			let fields = {
				amount: {},
				remarks:{}
			}

			fields = vuelidateUtil.setFieldsRequired(fields, true);

			return fields;
		},
		isInvalid() {
			const { $invalid } = this.$v;
			return $invalid || this.isAPILoading;
		}
	},
	beforeDestroy() {
		this.closeModal();
	},
	methods: {
		resetModalData() {
			Object.assign(this.$data, this.initializeModalData());
			this.$v.$reset();
		},
		initializeModalData() {
			return {
				selectedButton: 'ADD',
				amount: '0.00',
				remarks: "",
				isNotifyUser: true,
				isAPILoading: false
			}
		},
		show() {
			this.resetModalData();
			$(this.$refs.modalUpdateStoreCredit).modal('show');
		},
		closeModal() {
			$(this.$refs.modalUpdateStoreCredit).modal('hide');
		},
		selectButton(buttonName) {
			this.selectedButton = buttonName;
		},
		async updateStoreCredit(){
			await this.callUpdateStoreCreditAPI();
			this.isAPILoading = false;
			this.closeModal();
		},
		callUpdateStoreCreditAPI() {
			const { customerId }= this.modalContent;
			
			const creditDetails = {
				amount:this.amount,
				remarks: this.remarks,
				sendNotification: this.isNotifyUser
			};

			if(this.selectedButton === 'DEDUCT'){
				creditDetails.add = false;
			}

			this.isAPILoading = true;

			return StoreCreditService.updateStoreCredit(customerId, creditDetails)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.showCustomSuccessToast('Successfully update store credit.');
						this.$emit('refreshTableContent');
					} else {
						this.showAPIErrorToast('Unable to update store credit', res);
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isAPILoading = false;
				});
		}
	},
	validations() {
		return this.validationRules;
	}
}